import { Breakpoint, SxProps, Theme, useTheme } from '@mui/material/styles';
import { CSSProperties } from 'react';

export const useSectionFieldStyles = (
	collapseAt: Breakpoint = 'md',
	labelWidth: CSSProperties['width'] = '300px'
) => {
	const theme = useTheme();

	return {
		fieldContainer: {
			display: 'flex',
			columnGap: 1,
			flexDirection: 'row',

			[theme.breakpoints.down(collapseAt)]: {
				flexDirection: 'column'
			}
		},

		label: {
			maxWidth: labelWidth ?? '',
			minWidth: labelWidth ?? '',

			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
			color: 'text.fadedPrimary',
			fontWeight: 700,
			fontSize: '1rem',
			lineHeight: 'unset',

			[theme.breakpoints.down(collapseAt)]: {
				width: '100%',
				maxWidth: '100%',
				minWidth: 'unset',
				fontWeight: '700 !important'
			}
		},

		valueContainer: {
			display: 'flex',
			flexDirection: 'column',
			gap: 1,
			flex: '1 1 auto',
			minWidth: 0,
			maxWidth: `calc(100% - ${labelWidth} - var(--mui-spacing))`,

			[theme.breakpoints.down(collapseAt)]: {
				maxWidth: '100%'
			}
		},

		value: (isLink: boolean) => ({
			color: 'text.fadedPrimary',
			fontWeight: 400,
			fontSize: '1rem',
			flexWrap: 'wrap',
			overflowWrap: isLink ? 'unset' : 'break-word',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: isLink ? 'nowrap' : 'normal',
			display: 'block',
			maxWidth: isLink ? '42ch' : 'unset',
			lineHeight: 'unset'
		}),

		groupName: {
			color: 'text.secondary',
			fontWeight: 400,
			fontSize: '0.75rem',
			marginBottom: -1
		},

		editableField: {
			'& [data-pen]': {
				opacity: 0,
				pointerEvents: 'none',
				transition: 'opacity 120ms ease-in-out'
			},

			'@media (hover: hover)': {
				'&:hover [data-pen], &:has(:focus-visible) [data-pen]': {
					opacity: 1,
					pointerEvents: 'auto'
				}
			}
		},

		lockedField: {
			'& [data-locked]': {
				opacity: 0,
				pointerEvents: 'none',
				transition: 'opacity 120ms ease-in-out'
			},

			'@media (hover: hover)': {
				'&:hover [data-locked]': {
					opacity: 1
				}
			}
		},

		notEditableHint: {
			alignSelf: 'baseline',
			flexShrink: 0,
			color: 'text.disabled',
			fontWeight: 700,
			fontSize: '0.75rem',
			lineHeight: 1.5,
			textTransform: 'uppercase',
			whiteSpace: 'nowrap',
			paddingX: 1,
			cursor: 'default'
		},

		editableFieldTouch: (touchEditVisible: boolean): SxProps<Theme> => ({
			[theme.breakpoints.up('md')]: {
				'@media (hover: none)': {
					'& [data-pen]': {
						opacity: touchEditVisible ? 1 : 0,
						pointerEvents: touchEditVisible ? 'auto' : 'none'
					}
				}
			}
		}),

		editableValue: {
			display: 'inline-flex',
			alignItems: 'baseline',
			gap: 0.5,
			maxWidth: '100%'
		},

		editableValueList: {
			display: 'flex',
			flexDirection: 'column',
			gap: 1,
			minWidth: 0
		}
	};
};
